/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_No_Plan_DescriptionInputs */

const en_case_payment_no_plan_description = /** @type {(inputs: Case_Payment_No_Plan_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No payment plan has been created yet.`)
};

const pt_br2_case_payment_no_plan_description = /** @type {(inputs: Case_Payment_No_Plan_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum plano de pagamento foi criado.`)
};

/**
* | output |
* | --- |
* | "No payment plan has been created yet." |
*
* @param {Case_Payment_No_Plan_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_no_plan_description = /** @type {((inputs?: Case_Payment_No_Plan_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_No_Plan_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_no_plan_description(inputs)
	return pt_br2_case_payment_no_plan_description(inputs)
});